import { render, staticRenderFns } from "./realTimeCallPolice.vue?vue&type=template&id=578d189e&scoped=true"
import script from "./realTimeCallPolice.vue?vue&type=script&lang=ts"
export * from "./realTimeCallPolice.vue?vue&type=script&lang=ts"
import style0 from "./realTimeCallPolice.vue?vue&type=style&index=0&id=578d189e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d189e",
  null
  
)

export default component.exports